/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { MarkupPanelOverlayRef } from './markup-panel-overlay-ref';
import { MapInteractionsService } from '../../../services/mapInteractions.service';
import { MatDialog } from '@angular/material/dialog';
import { MarkupTextDialogComponent } from './markup-text-dialog.component';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'dash-gis-markup-panel',
    templateUrl: './markup-dialog.component.html',
    styleUrls: [ './markup-dialog.component.scss' ]
})
export class MarkupDialogComponent implements OnInit {

    private _color: string;
    private _tool: string;

    /**
     * @param dialogRef {DialogRef}
     * @param dialog
     * @param mapInteractions
     */
    constructor(
        private dialogRef: DialogRef,
        private dialog: MatDialog,
        private mapInteractions: MapInteractionsService,
    ) {
        this._color = '#ff0000';
        this._tool = '';
    }

    public ngOnInit() {}

    public clear() {
        this.mapInteractions.clearMarkup();
    }

    public undo() {
        this.mapInteractions.undoMarkup();
    }

    public close() {
        this.mapInteractions.enablePanInteraction();
        this.dialogRef.close();
    }

    public setTool(tool) {
        this._tool = tool;
        this.mapInteractions.removeInteractions();
        this.mapInteractions.enableMarkup(this.markupTool, this.markupColor, null);
    }

    public getMarkupText() {
        const promptRef = this.dialog.open(MarkupTextDialogComponent);
        promptRef.afterClosed().subscribe((markupText) => {
            if (markupText) {
                this.markupTool = 'text';
                this.mapInteractions.enableMarkup(this.markupTool, this.markupColor, markupText);
            }
        });
    }

    public onColorSelected(color) {
        this.markupColor = color;
    }

    get markupTool() {
        return this._tool;
    }

    set markupTool(tool) {
        this._tool = tool;
    }

    get markupColor() {
        return this._color;
    }

    set markupColor(color) {
        this._color = color;
        if (this._tool) {
            this.mapInteractions.enableMarkup(this.markupTool, this.markupColor, null);
        }
    }

    get hasFeatures() {
        return this.mapInteractions.hasMarkupFeatures;
    }
}
